import { usePopupConfirmation } from 'components/PopupConfirmation'
import {
  fetchPutSupplyOrderDetail,
  OutboundSOAddEditSliceType,
  fetchGetSupplyOrderDetailItem,
  fetchGetSupplyOrderDetail,
} from 'features/SupplyOrder/redux/outboundSOAddEdit'
import { PutSupplyOrderDetailRequestType } from 'features/SupplyOrder/services/outboundSO'
import { numberOnly, removeZeroOnFirst } from 'helpers'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from 'store'
import { toastSuccess } from 'utils/toast'

type UseRowPropsType = {
  product: OutboundSOAddEditSliceType['products']['item'][0]
  supplyOrderRequest: PutSupplyOrderDetailRequestType['supplyOrderRequest']
}

const useRow = ({ product, supplyOrderRequest }: UseRowPropsType) => {
  const dispatch = useAppDispatch()

  const { id } = useParams<{ id: string }>()

  const [isEdit, setIsEdit] = useState(false)
  const [qty, setQty] = useState(product.productRequestQuantity.toString())

  const { handleOpenConfirmation } = usePopupConfirmation()

  const generatePayload = (productRequestQuantity: number) => ({
    supplyOrderRequest,
    supplyOrderItemRequest: [
      {
        productDetailId: product.supplyOrderProductDetailId,
        productId: product.productId,
        productQrCode: product.productQrCode,
        productStatusId: product.productInventoryStatusId,
        productStatusNoteId: product.productInventoryStatusNoteId,
        productStock: product.productStock,
        supplyOrderItemId: product.supplyOrderItemId,
        supplyOrderItemIdList: product.supplyOrderItemIdList,
        productRequestQuantity,
      },
    ],
  })

  const handleChangeQty = (value: string) => {
    const newValue = removeZeroOnFirst(numberOnly(value))
    setQty(newValue)
  }

  const handleIsEdit = (val: boolean) => {
    setQty(product.productRequestQuantity.toString())
    setIsEdit(val)
  }

  const handleSave = () => {
    dispatch(
      fetchPutSupplyOrderDetail({
        supplyOrderId: Number(id),
        payload: generatePayload(Number(qty)),
        onSuccess: async () => {
          toastSuccess('Jumlah produk berhasil diperbarui')
          dispatch(fetchGetSupplyOrderDetail(Number(id)))
          await dispatch(
            fetchGetSupplyOrderDetailItem({
              supplyOrderId: Number(id),
              params: {
                pageIndex: 0,
              },
            }),
          ).unwrap()
          setIsEdit(false)
        },
      }),
    )
  }

  const handleDelete = () => {
    handleOpenConfirmation({
      type: 'danger',
      title: 'Konfirmasi Hapus Produk',
      message: `Apakah Anda yakin ingin menghapus produk ${product.productName}?`,
      onSubmit: () => {
        dispatch(
          fetchPutSupplyOrderDetail({
            supplyOrderId: Number(id),
            payload: generatePayload(0),
            onSuccess: async () => {
              toastSuccess('Produk berhasil dihapus')
              dispatch(fetchGetSupplyOrderDetail(Number(id)))
              await dispatch(
                fetchGetSupplyOrderDetailItem({
                  supplyOrderId: Number(id),
                  params: {
                    pageIndex: 0,
                  },
                }),
              ).unwrap()
              setIsEdit(false)
            },
          }),
        )
      },
    })
  }

  return {
    isEdit,
    qty,
    handleChangeQty,
    handleDelete,
    handleIsEdit,
    handleSave,
  }
}

export default useRow
